import React, { Component, createContext, useContext } from "react";
import { db } from "../config/Firebase";
const DataContext = createContext();

export const useData = ()=> useContext(DataContext);
const values = ["tags","persons","payments"];
const components = ["website_details","about_link","social_icon_1","social_icon_2","social_icon_3","social_icon_4","social_icon_5","join_us_link","about_banners","join_us_banners","thank_you_banners"]
const pages = ["terms","faq","payment_checkboxes"];
const filtered = ["filteredPersons"]
class State {
  constructor(values=[]){
    values.forEach(el=>{
      this[el] = [];
      this[`${el}Loaded`] = false;
    })
  }
}


class DataContextProvider extends Component {
  state = {
    ...new State(values),
    ...new State(components),
    ...new State(pages),
    ...new State(filtered),
    pageLoaded: false,
    allLoaded: false,
    webIcon: {}
  };
  getData = (type,typeLoaded)=>{
    this.setState({[typeLoaded]: false});
    const onSnapshot = snapShot=>{
      const array = [];
      snapShot.forEach(doc=>{
        const data = doc.data();
        data.id = doc.id;
        array.push(data);
      });
      this.setState({[type]: array,[typeLoaded]: true});
    }
    db.collection(type).onSnapshot(onSnapshot);
  }
  updateData = (type,id,update,resolve,reject)=>{
    db.collection(type).doc(id).update(update).then(resolve).catch(reject);
  }
  addData = (type,add,resolve,reject)=>{
    db.collection(type).add(add).then(resolve).catch(reject);
  }
  setFiltered = (filteredPersons=[],filteredPersonsLoaded=false) => this.setState({filteredPersons,filteredPersonsLoaded})
  pages = (el)=> db.collection("pages").doc(`${el}:${el}`)
  componentDidMount(){
    values.forEach(el=> this.getData(el,el+"Loaded"));
    components.forEach(el=>{
      this.setState({[el+"Loaded"]: false})
      db.collection("about").doc(`${el}:${el}`).onSnapshot(doc=>{
        const about_ = {...doc.data()};
        if(doc.exists) about_.id = doc?.id;
        this.setState({[el]: about_,[el+"Loaded"]: true})
      })
    })
    pages.forEach(el=> {
      this.setState({[el+"Loaded"]: false})
      this.pages(el).onSnapshot(doc=>{
        const page = {...doc.data()};
        page.id = doc.id
        this.pages(el).collection("data").onSnapshot(docs=>{
          page.data = [];
          docs.forEach(el=> {
            const dta = el.data();
            dta.id = el.id
            page.data.push(dta);
          });
          this.setState({[el]: page,[el+"Loaded"]: true})
        })
      })
    })
    
    window.addEventListener("load", () => this.setState({pageLoaded: true}));
  }

  delete = (collection,id,reject)=>{
    db.collection(collection).doc(id).delete().catch(reject)
  }
  UNSAFE_componentWillUpdate(prevProps, prevState){
    const { pageLoaded, allLoaded } = prevState;
    if( !values.map(el=> prevState[`${el}Loaded`]).includes(false) && !pages.map(el=> prevState[`${el}Loaded`]).includes(false) && pageLoaded && !allLoaded){
      this.setState({allLoaded: true});
      const loaders = document.querySelectorAll(".loader_wrapper");
      loaders.forEach(el=> el.classList.add("hide"));
      setTimeout(() => {
        loaders.forEach(el=> el.remove())
      }, 1000);
    }
    if(prevState.persons!==this.state.persons){
      this.setFiltered(prevState.persons,true)
    }
  }
  addSubcategory = (categoryId,value,resolve,reject)=> db.collection("categories").doc(categoryId).collection("subcategories").add(value).then(resolve).catch(reject);
  get = a=>a.current.value
  render() {
    return (
      <DataContext.Provider value={{...this.state,components,setFiltered: this.setFiltered,values,getPages: this.pages,pages,addSubcategory:this.addSubcategory,get: this.get,getData: this.getData,delete: this.delete,updateData: this.updateData,addData: this.addData}}>
        {this.state.allLoaded && this.props.children}
      </DataContext.Provider>
    );
  }
}

export default DataContextProvider;
